import * as React from 'react';
import './appErrorBoundary.scss';
import { FallbackProps } from 'react-error-boundary';
import { useAppConfigs } from '@config/config.hooks';
import { ReportErrorButton } from './ReportErrorButton';

export interface IAppErrorBoundaryProps extends FallbackProps {}

export const AppErrorBoundary: React.FC<IAppErrorBoundaryProps> = ({ error, resetErrorBoundary }) => {
  const appConfigs = useAppConfigs();
  return (
    <div className="gcl-gems-app-error-boundary-container">
      <div className="gcl-gems-app-error-boundary-content">
        <div className="gcl-gems-app-error-boundary-logo">
          <img alt="gammon-logo" src="https://logo.gammonconstruction.com/Icon_R.png" className="gcl-mr-sm" />
          <img alt="gems-logo" src="/images/gems-logo.png" width="auto" />
        </div>
        <div className="gcl-gems-app-error-boundary-text">
          <b className="gcl-fs-md">System is currently unavailable due to unknown error.</b>
          <br />
          <br />
          <ReportErrorButton errorMessage={error.message} traceId={appConfigs.configs.traceId} />
        </div>
      </div>
    </div>
  );
};
